// extracted by mini-css-extract-plugin
export var productImage = "_od-1";
export var viewLink = "_od-2";
export var wishlistItem = "_od-0";